import { render } from "./SetNodePropertiesPopup.vue?vue&type=template&id=3feae0dd&scoped=true&ts=true"
import script from "./SetNodePropertiesPopup.vue?vue&type=script&lang=ts"
export * from "./SetNodePropertiesPopup.vue?vue&type=script&lang=ts"

import "./SetNodePropertiesPopup.vue?vue&type=style&index=0&id=3feae0dd&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3feae0dd"]])

export default __exports__